import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/$slug/")({
  component: SlugIndex,
});

function SlugIndex() {
  const { slug } = Route.useParams();
  return (
    <Navigate
      to="/organization/$slug/overview"
      params={{ slug }}
      replace
    />
  );
}
